import React, { useState, useEffect } from 'react';
import { Table, Card, Typography, Skeleton, message, Flex } from 'antd';
import { getApplicationsByContestant } from '../../api/application';
import { useSettings } from '../../contexts/settingsContext';
import { searchContestants } from '../../api/contestant';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // For time zone handling    
import timezone from 'dayjs/plugin/timezone'; // For time zone handling    

dayjs.extend(utc);
dayjs.extend(timezone);

const { Title } = Typography;

const Schedule = () => {
    const { state: settings } = useSettings();
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                // Fetch applications for the contestant   
                const contestant = await searchContestants();
                const contestantId = contestant[0]._id;
                const applicationsData = await getApplicationsByContestant(contestantId);

                // Filter applications for the selected round and where paid is true   
                const currentApplications = applicationsData
                    .filter(app => app.round === settings.selectedRound && app.paid)
                    .sort((a, b) => new Date(a.date) - new Date(b.date)); // Sort by date   

                // Set applications to state   
                setApplications(currentApplications);
                setLoading(false);
            } catch (error) {
                console.error(`Failed to load applications: ${error}`);
                message.error('Failed to load applications.');
                setLoading(false);
            }
        };
        fetchApplications();
    }, [settings.selectedRound, settings.contestantId]);

    // Define columns for the table   
    const columns = [
        {
            title: 'Event',
            dataIndex: 'event',
            key: 'event',
            render: (event, record) => {
                if (event) {
                    const groupName = record.group ? ` - (${record.group.group_name})` : '';
                    return `${event.name} - ${event.style}${groupName}`;
                }
                return 'No Event';
            },
        },
        {
            title: 'Scheduled Start',
            dataIndex: 'date',
            key: 'date',
            render: (date) =>
                date ? dayjs.utc(date).tz('Europe/Bucharest').format('YYYY-MM-DD HH:mm') : 'Not Scheduled',
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
        },
        {
            title: 'Venue',
            dataIndex: 'event',
            key: 'venue',
            render: (event) => (event && event.venue ? event.venue.venue : 'No Venue'),
        },
    ];

    return (
        <div className="schedule-container">
            <Flex style={{ marginBottom: '15px' }} className='dashboard_page_header_area' align="center" justify="space-between">
                <Title className='dashboard_page_title' level={4} style={{ margin: 0 }}>My Schedule</Title>
            </Flex>
            <Card bordered={false} className="applications-card">
                {loading ? (
                    <Skeleton active />
                ) : (
                    <>
                        <Table
                            dataSource={applications}
                            columns={columns}
                            rowKey="_id"
                            pagination={{ pageSize: 10 }}
                            scroll={{ x: true }}
                        />
                    </>
                )}
            </Card>
        </div>
    );
};

export default Schedule;  